// extracted by mini-css-extract-plugin
export var csatScore = "_ny-5";
export var header = "_ny-1";
export var panelWrapper = "_ny-2";
export var postPreview = "_ny-3";
export var rightContent = "_ny-0";
export var wrappingText = "_ny-4";